import { aetherApi } from './aetherApi';

const punchoutApi = aetherApi.injectEndpoints({
  endpoints: (builder) => ({
    createPunchOutRequest: builder.mutation<
      { orderMsg: string; to: string },
      { sessionId: string }
    >({
      query: (body) => ({
        url: 'api/v1/handler-punch-out/new-checkout',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreatePunchOutRequestMutation } = punchoutApi;
